import useSWR from 'swr'
import { swrFetcher } from './helpers'
import { Brand, Client } from './aboboApiTypes'

export const useClient = () => {
  const { data: response, error } = useSWR('/client', swrFetcher<Client>, {revalidateOnFocus: false})

  return {
    client: response?.data,
    isLoading: !error && !response,
    isError: error,
  }
}

export const useBranding = () => {
  const { data: response, error } = useSWR('/client/brand', swrFetcher<Brand>, {revalidateOnFocus: false})

  return {
    branding: response?.data,
    isLoading: !error && !response,
    isError: error,
  }
}